import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "./store";
import { customLogger } from "@/utils";

var lang = navigator.language || navigator.userLanguage;
if (lang == "fr" || lang.split("-")[0] == "fr") {
    // 'fr', 'fr-BE', ...
    lang = "fr";
} else {
    lang = "en";
}

const siteurl = window.location.href;
const regexag = /(avrilgau)/g;
const regexfi = /(feteimperiale)/g;
const foundag = siteurl.search(regexag);
const foundfi = siteurl.search(regexfi);
customLogger("lang: ", lang)
//pour AG ou FI on veut la langue du site et pas celle du navigateur
if (foundag > 0 || foundfi > 0) {
    const regex = /(en\.)/g;
    const found = siteurl.search(regex);
    customLogger("regex en:", found)
    if (found > 0) {
        lang = "en";
    } else {
        lang = "fr";
    }
}

if (window.cleed_store_GUID == "f721cb37-de7f-4e7b-9760-1755cfd670bb") { // Guid of Carven beacause can't acces storeId here
    let lang_carven = ""
    if (!!document.querySelector('html body#html-body.cms-home.cms-index-index.page-layout-1column.sliderwhite.nodots.webp div.page-wrapper header.page-header div.panel.wrapper div.panel.header div#switcher-language.switcher.language.switcher-language div.actions.dropdown.options.switcher-options div#switcher-language-trigger.action.toggle.switcher-trigger span')) {
        lang_carven = document.querySelector('html body#html-body.cms-home.cms-index-index.page-layout-1column.sliderwhite.nodots.webp div.page-wrapper header.page-header div.panel.wrapper div.panel.header div#switcher-language.switcher.language.switcher-language div.actions.dropdown.options.switcher-options div#switcher-language-trigger.action.toggle.switcher-trigger span').innerText
        if (lang_carven == "Français")
            lang = "fr"
        else
            lang = "en"
    }
}

if (window.cleed_store_GUID == "fbffdb77-508c-45b3-aec0-ed3bc7a9bb0b") { // Guid of Cleed.ai beacause can't acces storeId here
    const regex = /(\/fr)/g;
    const found = siteurl.search(regex);
    customLogger("regex en:", found)
    if (found > 0) {
        lang = "fr";
    } else {
        lang = "en";
    }
}
if (window.cleed_store_GUID == "d563b6ec-4cba-4c4f-a4c8-3b35b2d4d685") { // Guid of LEX
    let lang_lex = siteurl.split("://")[1].split("/")[1].split("-")[1];
    lang = (lang_lex == "fr") ? "fr" : "en";
}

if (window.cleed_store_GUID == "c14fbf91-c8d1-4546-90b4-216020f1e6b9") { // Guid of Noo
    let lang_noo;
    let lang_default = lang
    try {
        lang_noo = document.querySelector('#weglot-switcher-1 aside div').getAttribute('data-l');
    } catch (e) {
        lang_noo = lang_default;
    }
    lang = (lang_noo === "fr" || lang_noo === "en") ? lang_noo : lang_default;
}

if (window.cleed_store_GUID == "2fea2328-a6c7-4a2f-9458-63097c8fead6") { // Guid of Oseree
    lang = 'en';
}

if (window.cleed_store_GUID == "26caaafd-3570-454c-9533-6fb45e6f3b1a") { // Guid of levallois
    lang = 'fr';
}

if(window.cleed_store_GUID == "3a2c23eb-1ccd-4f9b-ae09-c793f335cd39") {  // GUID of Formacast
    lang = "fr";
}

if(window.cleed_store_GUID == "7b550506-2caa-4704-8a74-4054979180f2") {  // GUID of ARBS
    lang = "fr";
}


if (window.cleed_store_GUID == "2948ab85-18f1-4b9e-93fb-32e20e46bf60") { // Guid of Smartzer
    lang = 'en';
}

if (window.cleed_store_GUID == "0b17a293-a68c-47a3-94fa-ac6a57b655d2") { // Guid of Rueil
    lang = 'fr';
}

customLogger("lang: ", lang)
store.commit("SET_LANG", lang);

Vue.use(VueI18n);

Vue.config.lang = lang;

export const i18n = {
    get: () => {
        const messages = store.state.config.i18n

        return new VueI18n({
            locale: lang, // set locale
            silentTranslationWarn: true,
            messages
        })
    }
}
